import React from 'react';
import { connect } from '../../../common/components/runtime-context';

type Props = {
  children?: React.ReactNode;
  className?: string;
  goBack: () => void;
};

export const BackButton = ({ children, className, goBack: handleClick }: Props) => (
  <button className={className} onClick={handleClick}>
    {children}
  </button>
);

import { type Actions, type AppState } from '../../../common/types';

const mapRuntimeToProps = (_state: AppState, _ownProps: {}, actions: Actions) => ({
  goBack: actions.goBack,
});

export default connect(mapRuntimeToProps)(BackButton);
